module.exports = __webpack_public_path__ + "static/img/logo.5e2c2e6d.png";